import { forwardRef } from 'react';

import { type ImageToken, RemoteImage, type RemoteImageProps } from '../RemoteImage/RemoteImage';

export type ImageAssetData = { has_dark_mode: boolean; height: number; name: string; width: number };

export type ServerDrivenImageProps = {
	imageAsset: ImageAssetData;
} & Omit<RemoteImageProps, 'token' | 'alt'> & { alt?: string };

const mapServerDrivenImageData = (data: ImageAssetData) => {
	const { name, has_dark_mode, width, height } = data;

	return { name: name as ImageToken, width, height, hasDarkMode: has_dark_mode };
};

export const ServerDrivenImage = forwardRef<HTMLImageElement, ServerDrivenImageProps>(
	({ imageAsset, alt, ...props }, ref) => {
		const { name, width, height } = mapServerDrivenImageData(imageAsset);

		return <RemoteImage token={name} alt={alt ?? name} width={width} height={height} ref={ref} {...props} />;
	},
);
